import { Binding, GraphObject, Shape } from 'gojs';
import { DataLineageThemeColors, LINEAGE_PARTS } from '../../../../../../state/data-lineage-diagram';

const $ = GraphObject.make;

export const nodeShape = (bindings: Binding[] = []) =>
  $(
    Shape,
    'RoundedRectangle',
    {
      name: LINEAGE_PARTS.NODE_BACKGROUND_NAME,
      fill: DataLineageThemeColors.Light.NodeFill,
      strokeWidth: 2,
    },
    ...bindings,
  );
